import { render } from "./IconImage.vue?vue&type=template&id=1dca1036"
import script from "./IconImage.vue?vue&type=script&lang=ts"
export * from "./IconImage.vue?vue&type=script&lang=ts"
script.render = render

export default script